import * as React from 'react';

import { connect } from 'react-redux';
import { RouterState } from 'connected-react-router';
 
export interface ScrollToTopProps {
  location: RouterState['location'];
}

class ScrollToTopContainer extends React.Component<ScrollToTopProps> {
  componentDidUpdate(prevProps: ScrollToTopProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

interface StateProps {
  router: RouterState;
}

export const ScrollToTop = connect((state: StateProps) => ({
  location: state.router.location,
}))(ScrollToTopContainer);